/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersinviterotate2Inputs */

const en_membersinviterotate2 = /** @type {(inputs: Membersinviterotate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New link`)
};

const de_membersinviterotate2 = /** @type {(inputs: Membersinviterotate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Link`)
};

/**
* | output |
* | --- |
* | "New link" |
*
* @param {Membersinviterotate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersinviterotate2 = /** @type {((inputs?: Membersinviterotate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersinviterotate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersinviterotate2(inputs)
	return de_membersinviterotate2(inputs)
});
export { membersinviterotate2 as "membersInviteRotate" }